import {GetResource} from "../utils/HttpUtil";

export function GetMenu(menu) {
    return GetResource(`/menuGroups/${menu}`);
}
